import { FabricImage } from 'fabric';

export type ImageFit = 'cover' | 'contain' | 'none';

export type ImageBox = { width: number; height: number };

/** Scales the image so its rendered size matches `target`. Mutates scaleX/scaleY. */
export function fitImage(img: FabricImage, fit: ImageFit, target: ImageBox): void {
  if (fit === 'none') return;
  const nativeW = img.width ?? 0;
  const nativeH = img.height ?? 0;
  if (!nativeW || !nativeH || !target.width || !target.height) return;

  const scaleX = target.width / nativeW;
  const scaleY = target.height / nativeH;
  const scale = fit === 'cover' ? Math.max(scaleX, scaleY) : Math.min(scaleX, scaleY);

  img.set({ scaleX: scale, scaleY: scale });
}
